import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MiniMark } from "@/components/HeroLogo";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[rgba(6,42,34,0.88)] backdrop-blur-md border-b border-[rgba(179,145,74,0.22)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto w-full max-w-[1120px] px-5 sm:px-6">
        <div className="flex items-center justify-between h-16 sm:h-[4.5rem]">
          <button
            data-testid="nav-logo-button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-baseline gap-2.5 group"
            aria-label="Back to top"
          >
            <MiniMark />
            <span className="hidden sm:block font-display text-[var(--hoa-cream-50)] text-lg tracking-wide">
              house of appetite
            </span>
          </button>

          <nav className="flex items-center gap-2 sm:gap-6">
            <button
              data-testid="nav-story-link"
              onClick={() => scrollToId("story")}
              className="hidden md:block font-label text-[11px] tracking-[0.22em] uppercase text-[rgba(240,233,216,0.75)] hover:text-[var(--hoa-gold-400)] transition-colors"
            >
              My Story
            </button>
            <button
              data-testid="nav-craft-link"
              onClick={() => scrollToId("craft")}
              className="hidden md:block font-label text-[11px] tracking-[0.22em] uppercase text-[rgba(240,233,216,0.75)] hover:text-[var(--hoa-gold-400)] transition-colors"
            >
              The Craft
            </button>
            <Link
              to="/orders"
              data-testid="nav-admin-link"
              className="inline-flex items-center h-9 px-4 rounded-full border border-[rgba(179,145,74,0.45)] font-label text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-[rgba(240,233,216,0.85)] hover:text-[var(--hoa-gold-400)] hover:bg-[rgba(240,233,216,0.06)] transition-colors"
            >
              Admin
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};
